import { MouseEvent as ReactMouseEvent } from "react"
import cn from "classnames"
import { useToggle } from "react-use"

import { ProfileLink } from "app/AppRouter/links"
import { Analytics } from "utils/analytics"
import { Text } from "ui-kit/components-branded"
import { Icon, NonImgAvatar } from "components"
import { getFaceUrl } from "utils/helpers/psychologistUtil"

interface Props {
    className?: string
    faceUrl: string
    hashId: string
    name: string
    title: string
    publicProfileUrl: string
    onClick?: (event: ReactMouseEvent<HTMLAnchorElement, MouseEvent>) => void
}

export function PsychologistProfile({
    faceUrl,
    hashId,
    publicProfileUrl,
    name,
    title,
    className,
    onClick,
}: Props) {
    const [error, toggleError] = useToggle(false)
    const _faceUrl = getFaceUrl(faceUrl, hashId)

    const handleClickLink = (event: ReactMouseEvent<HTMLAnchorElement, MouseEvent>) => {
        Analytics.lk_psy_profile()
        onClick?.(event)
    }

    return (
        <ProfileLink
            profileUrl={publicProfileUrl}
            className={cn(className, "sessions__card__header is-flex is-align-items-center")}
            target="_blank"
            onClick={handleClickLink}
        >
            <div
                className={cn("sessions__card__avatar", {
                    "is-image": !error,
                })}
            >
                {!error && (
                    <img
                        src={_faceUrl}
                        alt={name}
                        srcSet={`${_faceUrl} 2x`}
                        onError={() => toggleError()}
                    />
                )}
                {error && (
                    <NonImgAvatar size="S" isInverted={true}>
                        {name}
                    </NonImgAvatar>
                )}
            </div>
            <div className="sessions__card__text-wrapper is-flex-grow-1">
                <Text>{name}</Text>
                <div className="sessions__card__main-info__title">{title || "психолог"}</div>
            </div>
            <Icon type="arrow-right-gray" size={24} />
        </ProfileLink>
    )
}
